import React from 'react';

const ContractorSliderBackgroundVector = ({ ...props }) => (
  <svg
    width="378"
    height="416"
    viewBox="0 0 378 416"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M378 347.447C378 351.549 377.194 355.61 375.627 359.4C374.06 363.189 371.763 366.632 368.868 369.533C365.973 372.433 362.536 374.733 358.754 376.303C354.971 377.873 350.917 378.681 346.823 378.681H338.63V408.192C338.63 410.263 337.809 412.249 336.347 413.713C334.886 415.177 332.903 416 330.836 416H51.2282C49.161 416 47.1785 415.177 45.7168 413.713C44.255 412.249 43.4339 410.263 43.4339 408.192V378.681H31.1773C22.9086 378.681 14.9785 375.39 9.1316 369.533C3.28472 363.675 0 355.731 0 347.447V117.126C0 86.0619 12.3178 56.2706 34.2436 34.3053C56.1694 12.34 85.9071 0 116.915 0H261.085C292.093 0 321.831 12.34 343.756 34.3053C365.682 56.2706 378 86.0619 378 117.126V347.447Z"
      fill="#003E7D"
    />
  </svg>
);

export default ContractorSliderBackgroundVector;
